
define('text!templates/pages/wishlist/offers/page.ejs',[],function () { return '<div class="page-nav clearfix">\n    <div class="pull-right mt">\n        <div class="navbar-search ml mt0 pull-right">\n            <input type="text" class="search-query" placeholder="Поиск" value="" style="width: 226px">\n        </div>\n    </div>\n</div>\n\n<div class="filter-summary-container">\n</div>';});

